// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"3d22caed","787":"c3cddf2e"}[chunkId] + ".chunk.js";
};